import React from "react";

const PercentageDisplay = ({ quantity }) => <p>{quantity} %</p>;

export default PercentageDisplay;
